import axios from "axios";

export const BASE_URL = "https://api.revolutionsoft.in/api/";
// export const BASE_URL = "http://localhost:7200/api";
const api = axios.create({
  baseURL: BASE_URL,
});
export default api;
